import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import Navbar from "../../components/Navbar/Navbar";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import axios from "axios";
import useRole from "../../utils/useRole";
import { getAxiosConfig } from "../../utils/helpers";
import BackBtn from "../../components/BackBtn";

const ProjectWrapper = () => {
  const { isAdmin, isSuperAdmin } = useRole();
  // const [projectData, setProjectData] = useOutletContext();
  // const {id} = useParams();
  const [data, setData] = useState(null);
  const [basicInfo, setBasicInfo] = useState({
    companyName: "",
    companyLogo: [],
    floorMap: [],
    address: "",
  });
  const { id } = useParams();
  const fetchProject = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/${id}`,
      );
      setData(response.data);
    } catch (error) {
      console.error("Failed to fetch project data", error);
    }
  };
  const fetchBasicInfo = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/get-base/${id}`,
        getAxiosConfig(),
      );
      // console.log("BASIC INFO", data);
      if (data?.data) {
        setBasicInfo(data.data);
      }
    } catch (error) {
      console.log("Failed to fetch basic info", error);
    }
  };
  useEffect(() => {
    fetchProject();
    fetchBasicInfo();
  }, [id]);
  return (
    <Layout>
      <Navigation basicInfo={basicInfo} />
      {isAdmin || isSuperAdmin ? (
        <Outlet
          context={{
            projectData: data,
            setProjectData: setData,
            fetchProject,
            basicInfo,
            setBasicInfo,
            fetchBasicInfo,
          }}
        />
      ) : (
        <Navigate to={"/unauthorized"} replace />
      )}
    </Layout>
  );
};
const Navigation = ({ activeLink, setActiveLink, basicInfo }) => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  let navigationLinks = [
    { name: "Basic Info", link: "basic-info" },
    { name: "Projects", link: "projects" },
    { name: "Material Design", link: "material" },
    { name: "Design", link: "design" },
  ];
  if (
    basicInfo?.companyLogo?.length > 0 &&
    basicInfo?.companyName &&
    basicInfo?.address
  ) {
    navigationLinks.push({ name: "Presentation", link: "presentation" });
  }

  return (
    <div className="my-4 p-3 mx-auto container rounded-xl border flex items-center gap-4 bg-white">
      <BackBtn className="cursor-pointer text-[#008080] hover:text-[#006666] w-6 h-6 transition-colors ml-2" />
      <div className="flex justify-around flex-1 items-center">
        {navigationLinks.map((link, i) => (
          <div
            key={i}
            onClick={() => nav(link.link, { replace: true })}
            className={`${
              pathname.includes(link.link) &&
              "font-bold bg-[#008080] text-white"
            } text-center p-3 flex-1 rounded-lg cursor-pointer transition duration-300 `}
          >
            {link.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectWrapper;
